/**
 * Copyright (c) ActiveWidgets SARL. All Rights Reserved.
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {jQueryComponent} from './framework.js';
import {Datagrid, Row, Cells} from '@activewidgets/datagrid';

jQueryComponent(Datagrid);
jQueryComponent(Row);
jQueryComponent(Cells);
